const locale = {
  en: {
    // common
    ETC: '其他',
    'GRADE.1': '学生',
    'GRADE.2': '教授/助教',
    'GENDER.1': '女',
    'GENDER.2': '男',
    'EXIST.SHORT.1': 'N',
    'EXIST.SHORT.2': 'Y',
    'NEED.1': 'Necessary',
    'NEED.2': 'Unnecessary',
    'NEEDED.1': 'Not Needed',
    'NEEDED.2': 'Needed',
    'YESORNO.1': '是',
    'YESORNO.2': '否',
    'PUBLIC.TRUE': 'X',
    'PUBLIC.FALSE': 'O',
    'NONE.EXIST.1': '无',
    'NONE.EXIST.2': 'Exist',

    'REQUIRED.KEYWORD': '請輸入關鍵字。',
    'REQUIRED.STRING': '請輸入姓名。',
    'REQUIRED.NUMBER': '請輸入 ID（數字）。',
    'REQUIRED.COLLEGENUMBER': '請輸入學校代碼（數字）。',

    // patient
    'PATIENT.MANAGE': '虛擬病人管理',
    'PATIENT.LIST': '虛擬病人清單',
    'PATIENT.CREATE': '建立虛擬病人',
    'PATIENT.CREATEEPIC': '建立虛擬病人（EPIC）',
    'PATIENT.UPDATE': '編輯虛擬病人',
    'PATIENT.DELETE': '刪除虛擬病人',
    'PATIENT.SELECT.EMPTY.TITLE': '請選擇患者。',
    'PATIENT.SELECT.EMPTY.DESCRIPTION':
      '點擊上方搜尋欄以搜尋實習患者，或從列表中選擇以啟用詳細數據。',
    'REQUIRED.PATIENT.ID': '請輸入有效的虛擬病人 ID 並進行搜尋。',
    'REQUIRED.UNIQUE.NO': '檢驗編號重複。',
    'REQUIRED.FEE.ID': '請輸入有效的檢驗代碼並進行搜尋。',
    'REQUIRED.PATHOLOGY': '請新增臨床病理檢驗清單。',
    'REQUIRED.RADIOLOGY': '請新增放射線檢查結果清單。',
    'REQUIRED.RADIOLOGY.MAX.FILE': '最多可上傳 5 個檔案。',
    'REQUIRED.MEDICATION': '請新增用藥紀錄清單。',
    'REQUIRED.UNIQUE.MEDICATION.NO': '用藥編號重複。',
    'REQUIRED.MEDICATION.ID': '請輸入有效的藥品代碼並進行搜尋。',
    'REQUIRED.DATE.TIME': '請輸入有效的時間值。',

    'CREATE.SCHOOL': '請選擇學校代碼。',
    'CREATE.MAINDISEASE': '請選擇主要診斷。',

    // error message
    'ERROR.CODE.0': 'An unknown error occurred. ErrorCode: {rc}',
    'ERROR.CODE.100':
      'There is a problem with your account. Please contact the administrator.',
    'ERROR.CODE.101': 'Email authentication code does not match',
    'ERROR.CODE.102': "The virtual patient's ID is incorrect",
    'ERROR.CODE.104': 'Recording paper ID is incorrect',
    'ERROR.CODE.105': 'Nursing record information not found',
    'ERROR.CODE.106':
      'You are an unauthorized user. Please contact the administrator',
    'ERROR.CODE.107': 'Passwords do not match',
    'ERROR.CODE.108':
      'This email address has already been registered. Please enter another Email.',
    'ERROR.CODE.109':
      'This is a virtual patient ID that already exists. Please enter another ID.',
    'ERROR.CODE.110':
      'School information could not be found. Please contact the administrator.',
    'ERROR.CODE.111':
      'You do not have permission. Please contact the administrator.',
    'ERROR.CODE.113':
      '同一所學校中，已有使用相同學號註冊的帳號。',
    'ERROR.CODE.201':
      'Insurance reimbursement code information could not be found',
    'ERROR.CODE.202': 'Drug code information could not be found',
    'ERROR.CODE.702': 'Not a valid file. Please check the file again',

    // signup
    'REQUIRED.EMAIL.FORMAT': 'The email format is incorrect',
    'REQUIRED.NAME.FORMAT': 'Please edit your name.',
    'REQUIRED.EMAIL.VERIFICATION':
      'Please check your email authentication code',
    'REQUIRED.PASSWORD.FORMAT':
      'Please enter the password at least 8 digits including English + numbers + special symbols.',
    'REQUIRED.PASSWORD.CONFIRM': 'The passwords you entered do not match',
    'REQUIRED.COLLEGE': 'Please select a school',
    'REQUIRED.STUDENT.NO': 'Please check your student ID number.',
    'REQUIRED.PASSWORD.CONFIRMTRUE':
      'Enter your password and press the confirm button.',
    'REQUIRED.PASSWORD.CONFIRMTWO': 'Please enter new password confirmation.',
    'REQUIRED.PASSWORD.RECHECKED':
      'Please enter a password with at least 8 characters, including letters, numbers, and special characters.',

    // Main
    'REQUIRED.STUDENT': 'No student has been selected.',
    'REQUIRED.PATIENT': 'No patient has been selected.',
    'REQUIRED.NONCHOICE': '請填寫所有必填欄位。',

    //CoreNursingSkillVideo
    'REQUIRED.VIDIEO.FORMAT': 'You cannot upload files larger than 500 MB.',

    // nursing record
    'RECORD.0': 'NANDA',
    'RECORD.1': 'SOAPIE',
    'RECORD.2': 'Focus DAR',
    'RECORD.3': 'Narrative',
    'RECORD.4': 'Nursing Process',
    'RECORD.TYPE.0': 'NANDA',
    'RECORD.TYPE.1': 'SOAPIE',
    'RECORD.TYPE.2': 'FOCUSDAR',
    'RECORD.TYPE.3': 'NARRATIVE',
    'RECORD.TYPE.4': 'REMARKS',
    'NANDA.DOMAIN': 'Domain',
    'NANDA.CLASS': 'Class',
    'NANDA.DIAGNOSIS': 'Diagnosis',
    'NANDA.COLLECTINGDATA': 'Subjective/Objective Data Collection',
    'NANDA.GOAL': 'Short-term/Long-term Goals',
    'NANDA.PLAN': 'Nursing Plan',
    'NANDA.INTERVENTIONS': 'Interventions',
    'NANDA.EVALUATION': 'Evaluation',
    'SOAPIE.SUBJECTIVE': 'Subjective Data',
    'SOAPIE.OBJECTIVE': 'Objective Data',
    'SOAPIE.ASSESSMENT': 'Assessment',
    'SOAPIE.PLANNING': 'Planning',
    'SOAPIE.INTERVENTIONS': 'Interventions',
    'SOAPIE.EVALUATION': 'Evaluation',
    'FOCUSDAR.FOCUS': 'Focus',
    'FOCUSDAR.DATA': 'Data',
    'FOCUSDAR.ACTION': 'Action',
    'FOCUSDAR.RESPONSE': 'Response',
    'NARRATIVE.NARRATIVENOTE': '敘述記錄',
    'REMARKS.ASSESSMENT': 'Nursing Assessment',
    'REMARKS.DIAGNOSIS': 'Nursing Diagnosis',
    'REMARKS.DIAGNOSISRELATE': 'related to',
    'REMARKS.GOAL': 'Nursing Goal',
    'REMARKS.PLAN': 'Nursing Plan',
    'REMARKS.INTERVENTIONS':
      'Nursing Perform / arbitration / Theoretical Interventions',
    'REMARKS.EVALUATION': 'Nursing Evaluation',
    'REQUIRED.RECORD.TIME': 'Enter Nursing Record Time',

    // hospitalization
    'HOSPITALIZATION.PATH.1': '門診',
    'HOSPITALIZATION.PATH.2': 'ER',
    'HOSPITALIZATION.WAY.1': 'On Foot',
    'HOSPITALIZATION.WAY.2': '輪椅',
    'HOSPITALIZATION.WAY.3': 'Stretch Car',
    'HOSPITALIZATION.STATUS.1': '清醒',
    'HOSPITALIZATION.STATUS.2': '嗜睡',
    'HOSPITALIZATION.STATUS.3': '昏迷不醒',
    'HOSPITALIZATION.STATUS.4': 'Semicoma',
    'HOSPITALIZATION.STATUS.5': '昏迷',
    'HOSPITALIZATION.STATUS02.1': 'Smooth',
    'HOSPITALIZATION.STATUS02.2': 'Difficult',
    'HOSPITALIZATION.STATUS02.3': 'Impossible',

    'HOSPITALIZATION.DISEASE.HISTORY.1': 'HTN',
    'HOSPITALIZATION.DISEASE.HISTORY.2': 'DM',
    'HOSPITALIZATION.DISEASE.HISTORY.3': 'TBc',
    'HOSPITALIZATION.DISEASE.HISTORY.4': 'Hep',
    'HOSPITALIZATION.DISEASE.HISTORY.5': 'Cancer',

    'HOSPITALIZATION.BODY.CYCLE.1': 'Chest Pain',
    'HOSPITALIZATION.BODY.CYCLE.2': 'Palpitation',
    'HOSPITALIZATION.BODY.CYCLE.3': 'Arrhythmia',
    'HOSPITALIZATION.BODY.CYCLE.4': 'Pacemaker',
    'HOSPITALIZATION.BODY.BREATH.1': 'Dyspnea',
    'HOSPITALIZATION.BODY.BREATH.2': 'Cough',
    'HOSPITALIZATION.BODY.BREATH.3': 'Sputum',
    'HOSPITALIZATION.BODY.BREATH.4': 'Hemoptysis',
    'HOSPITALIZATION.BODY.CAMOUFLAGE.1': 'Nausea',
    'HOSPITALIZATION.BODY.CAMOUFLAGE.2': 'Vomiting',
    'HOSPITALIZATION.BODY.CAMOUFLAGE.3': 'Abdominal Pain',
    'HOSPITALIZATION.BODY.CAMOUFLAGE.4': 'Dysphagia',
    'HOSPITALIZATION.BODY.NERVE.1': 'Paralysis',
    'HOSPITALIZATION.BODY.NERVE.2': 'Numbness',
    'HOSPITALIZATION.BODY.NERVE.3': 'Paresthesia',
    'HOSPITALIZATION.BODY.NERVE.4': 'Dizziness',
    'HOSPITALIZATION.BODY.SKIN.1': 'Rash',
    'HOSPITALIZATION.BODY.SKIN.2': 'Pruritis',
    'HOSPITALIZATION.BODY.SKIN.3': 'Edema',
    'HOSPITALIZATION.BODY.SKIN.4': 'Ulcer',

    'HOSPITALIZATION.HABIT.OBG.1': 'Not applicable',

    'HOSPITALIZATION.HABIT.FECES.1': 'Normal',
    'HOSPITALIZATION.HABIT.FECES.2': 'Diarrhea',
    'HOSPITALIZATION.HABIT.FECES.3': 'Melena',
    'HOSPITALIZATION.HABIT.FECES.4': 'Constipation',
    'HOSPITALIZATION.HABIT.FECES.5': 'Artificial Anus',
    'HOSPITALIZATION.HABIT.URINE.1': 'Normal',
    'HOSPITALIZATION.HABIT.URINE.2': 'Dysuria',
    'HOSPITALIZATION.HABIT.URINE.3': 'Frequent',
    'HOSPITALIZATION.HABIT.URINE.4': 'Incontinence',
    'HOSPITALIZATION.HABIT.URINE.5': 'Ostomy',

    'HOSPITALIZATION.FUNCTIONAL.EVALUATION.1': 'Possible (0)',
    'HOSPITALIZATION.FUNCTIONAL.EVALUATION.2': 'Need Help (1)',
    'HOSPITALIZATION.FUNCTIONAL.EVALUATION.3': 'Impossible (2)',

    'HOSPITALIZATION.MARRY.1': 'Married',
    'HOSPITALIZATION.MARRY.2': 'Single',

    'HOSPITALIZATION.ECONOMY.MIND.1': 'Stable',
    'HOSPITALIZATION.ECONOMY.MIND.2': 'Anxious',
    'HOSPITALIZATION.ECONOMY.MIND.3': 'Sad',
    'HOSPITALIZATION.ECONOMY.MIND.4': 'Angry',
    'HOSPITALIZATION.ECONOMY.MIND.5': 'Depressed',

    'HOSPITALIZATION.EDUCATION.WAY.1': 'Verbal',
    'HOSPITALIZATION.EDUCATION.WAY.2': 'Prints',
    'HOSPITALIZATION.EDUCATION.WAY.3': 'Demonstration',
    'HOSPITALIZATION.EDUCATION.WAY.4': 'Verbal + Prints',
    'HOSPITALIZATION.EDUCATION.CONTENTS.1': 'Disease',
    'HOSPITALIZATION.EDUCATION.CONTENTS.2': 'Treatment',
    'HOSPITALIZATION.EDUCATION.CONTENTS.3': 'Medication',
    'HOSPITALIZATION.EDUCATION.CONTENTS.4': 'Nutrition',

    'HOSPITALIZATION.LIFE.1': '獨立',
    'HOSPITALIZATION.LIFE.2': 'Partial Help',
    'HOSPITALIZATION.LIFE.3': 'All Help',
    'HOSPITALIZATION.DESTINATION.1': 'Home',
    'HOSPITALIZATION.DESTINATION.2': 'Other Hospital',
    'HOSPITALIZATION.DESTINATION.3': 'Nursing Home',
    'HOSPITALIZATION.GUARDIAN.1': '无',
    'HOSPITALIZATION.GUARDIAN.2': '配偶',
    'HOSPITALIZATION.GUARDIAN.3': '父親',
    'HOSPITALIZATION.GUARDIAN.4': '母親',
    'HOSPITALIZATION.GUARDIAN.5': '子女',

    // out hospital
    'OUT.HOSPITAL.DESTINATION.1': '家中',
    'OUT.HOSPITAL.DESTINATION.2': '其他醫院',
    'OUT.HOSPITAL.DESTINATION.3': '護理之家',

    'OUT.HOSPITAL.WAY.1': '私人交通工具',
    'OUT.HOSPITAL.WAY.2': '公共交通工具',
    'OUT.HOSPITAL.WAY.3': '救護車',
    'OUT.HOSPITAL.WAY.4': '照護設施',

    'OUT.HOSPITAL.FOOD.1': '正常',
    'OUT.HOSPITAL.SHOWER.1': '淋浴',
    'OUT.HOSPITAL.SHOWER.2': '泡澡',
    'OUT.HOSPITAL.ACTIVITY.1': '限制',
    'OUT.HOSPITAL.ACTIVITY.2': '無限制',

    // clinical observation
    'CLINICAL.OBSERVATION.ADD.ROW': 'Please enter all required fields',
    'CLINICAL.OBSERVATION.STOP': 'Up to 5 entries per virtual patient',
    'CLINICAL.OBSERVATION.ADD.NAN':
      'Please enter only numbers for your contact information.',

    // bedScore
    'BED.SCORE.SENSORY.PERCEPTION.1': '完全受限',
    'BED.SCORE.SENSORY.PERCEPTION.2': '嚴重受限',
    'BED.SCORE.SENSORY.PERCEPTION.3': '輕微受限',
    'BED.SCORE.SENSORY.PERCEPTION.4': '無損傷',

    'BED.SCORE.HUMIDITY.1': '持續潮濕',
    'BED.SCORE.HUMIDITY.2': '非常潮濕',
    'BED.SCORE.HUMIDITY.3': '偶爾潮濕',
    'BED.SCORE.HUMIDITY.4': '很少潮濕',

    'BED.SCORE.ACTIVITY.1': '臥床',
    'BED.SCORE.ACTIVITY.2': '坐椅',
    'BED.SCORE.ACTIVITY.3': '偶爾行走',
    'BED.SCORE.ACTIVITY.4': '經常行走',

    'BED.SCORE.MOBILITY.1': '完全不能移動',
    'BED.SCORE.MOBILITY.2': '嚴重受限',
    'BED.SCORE.MOBILITY.3': '輕微受限',
    'BED.SCORE.MOBILITY.4': '無限制',

    'BED.SCORE.NUTRITION.1': '非常差',
    'BED.SCORE.NUTRITION.2': '可能不足',
    'BED.SCORE.NUTRITION.3': '足夠',
    'BED.SCORE.NUTRITION.4': '優秀',

    'BED.SCORE.FRICTION.1': '問題',
    'BED.SCORE.FRICTION.2': '潛在問題',
    'BED.SCORE.FRICTION.3': '無明顯問題',

    // needs
    'REQUIRED.NEEDS.BODY.STATUS': '신체상태 항목을 모두 선택해주세요',

    // fall
    'FALL.1': '无 (0 分)',
    'FALL.15': '有 (15 分)',
    'FALL.25': '有 (25 分)',
    'FALL.20': '有 (20 分)',
    'FALL.WALKING.AIDS.1': '无/卧床休息/护士协助 (0 分)',
    'FALL.WALKING.AIDS.15': '拐杖/手杖/助行器 (15 分)',
    'FALL.WALKING.AIDS.30': '家具 (30 分)',
    'FALL.GAIT.1': '正常/卧床休息/无法移动 (0 分)',
    'FALL.GAIT.10': '虚弱 (10 分)',
    'FALL.GAIT.20': '受损 (20 分)',
    'FALL.CONSCIOUSNESS.1': '能够意识到自己的能力 (0 分)',
    'FALL.CONSCIOUSNESS.15': '忘记自身限制 (15 分)',

    // 소아낙상
    'FALLSCALE.SCORE.AGE.1': '小於3個月，13歲及以上',
    'FALLSCALE.SCORE.AGE.2': '超過7歲 - 小於13歲',
    'FALLSCALE.SCORE.AGE.3': '超過3歲 - 小於7歲',
    'FALLSCALE.SCORE.AGE.4': '超過3個月 - 小於3歲',

    'FALLSCALE.SCORE.GENDER.1': '女性',
    'FALLSCALE.SCORE.GENDER.2': '男性',

    'FALLSCALE.SCORE.DIANOSIS.1': '其他診斷',
    'FALLSCALE.SCORE.DIANOSIS.2': '心理/行為障礙',
    'FALLSCALE.SCORE.DIANOSIS.3':
      '氧氣變化\n(呼吸疾病、脫水、貧血、厭食、暈厥/頭暈等)',
    'FALLSCALE.SCORE.DIANOSIS.4': '神經系統診斷',

    'FALLSCALE.SCORE.COGNITIVE.1': '對自己能力的認知',
    'FALLSCALE.SCORE.COGNITIVE.2': '忘記限制',
    'FALLSCALE.SCORE.COGNITIVE.3': '未意識到限制或小於4歲',

    'FALLSCALE.SCORE.ENVIRONMENTAL.1': '門診區域',
    'FALLSCALE.SCORE.ENVIRONMENTAL.2': '使用支架 (輪椅、助行器、拐杖)',
    'FALLSCALE.SCORE.ENVIRONMENTAL.3': '跌倒史',

    'FALLSCALE.SCORE.HISTORY.1': '超過48小時/无',
    'FALLSCALE.SCORE.HISTORY.2': '48小時內',
    'FALLSCALE.SCORE.HISTORY.3': '24小時內',

    'FALLSCALE.SCORE.DRUG.1': '其他藥物/无 ',
    'FALLSCALE.SCORE.DRUG.2': '上述列出的藥物之一',
    'FALLSCALE.SCORE.DRUG.3':
      '多重使用:\n(催眠藥、巴比妥類藥物、吩噻嗪類、抗抑鬱藥、瀉藥/利尿劑)',

    // safety
    'SAFETY.DISCOVERY.PLACE.1': '病房',
    'SAFETY.DISCOVERY.PLACE.2': '門診',
    'SAFETY.DISCOVERY.PLACE.3': '樓梯',
    'SAFETY.DISCOVERY.PLACE.4': '檢查室',
    'SAFETY.DISCOVERY.PLACE.0': '其他',

    'SAFETY.ACCIDENT.TYPE.1': 'Red light incident',
    'SAFETY.ACCIDENT.TYPE.2': 'Harmful incident',
    'SAFETY.ACCIDENT.TYPE.3': 'Proximity error',

    'SAFETY.ACCIDENT.CLASSIFICATION.1': '用藥錯誤',
    'SAFETY.ACCIDENT.CLASSIFICATION.2': '跌倒或受傷',
    'SAFETY.ACCIDENT.CLASSIFICATION.3': '不良反應',
    'SAFETY.ACCIDENT.CLASSIFICATION.4': '手術併發症',
    'SAFETY.ACCIDENT.CLASSIFICATION.5': '設備故障',
    'SAFETY.ACCIDENT.CLASSIFICATION.0': '其他',

    'SAFETY.EVENT.CLASSIFICATION.8':
      '[Red light incident]  level 8 : patient death',
    'SAFETY.EVENT.CLASSIFICATION.7':
      '[Red light incident] level 7 : near death situation of a patient  ',
    'SAFETY.EVENT.CLASSIFICATION.6':
      '[Red light incident] level 6 : incorrect site treatment and surgery; permanent damage',
    'SAFETY.EVENT.CLASSIFICATION.5':
      '[Harmful incident]  level 5 : Hospitalization due to temporary damage or extended hospitalization period',
    'SAFETY.EVENT.CLASSIFICATION.4':
      '[Harmful incident] level 4 :  Temporary damage requires intervention(Examination, internal/surgical treatment etc.)',
    'SAFETY.EVENT.CLASSIFICATION.3':
      '[Harmful incident] level 3 : Dose given to a patient and requires further observation',
    'SAFETY.EVENT.CLASSIFICATION.2':
      '[Harmful incident] level 2 : dose given to a patient without a further harm',
    'SAFETY.EVENT.CLASSIFICATION.1':
      '[Proximity error] level 1 : Accident did not affect a patient',
    'SAFETY.EVENT.CLASSIFICATION.0':
      '[Proximity error] level 0 : accidents with errors at risk',

    'SAFETY.TYPE.CONSCIOUSNESS.LEVEL.1': '清醒',
    'SAFETY.TYPE.CONSCIOUSNESS.LEVEL.2': '嗜睡',
    'SAFETY.TYPE.CONSCIOUSNESS.LEVEL.3': '混亂',
    'SAFETY.TYPE.CONSCIOUSNESS.LEVEL.4': '昏迷不醒',
    'SAFETY.TYPE.CONSCIOUSNESS.LEVEL.5': '昏迷',

    'SAFETY.TYPE.ACTIVITY.STATUS.1': '獨立',
    'SAFETY.TYPE.ACTIVITY.STATUS.2': '輪椅',
    'SAFETY.TYPE.ACTIVITY.STATUS.3': '助行器',
    'SAFETY.TYPE.ACTIVITY.STATUS.4': '限制在床/椅',

    'SAFETY.TYPE.ASSISTING.DEVICES.1': '輪椅',
    'SAFETY.TYPE.ASSISTING.DEVICES.2': 'Walking Aids',
    'SAFETY.TYPE.ASSISTING.DEVICES.0': 'No Use',

    'SAFETY.TYPE.PLACE.FALLING.ACCIDENT.1': '房間',
    'SAFETY.TYPE.PLACE.FALLING.ACCIDENT.2': '廁所',
    'SAFETY.TYPE.PLACE.FALLING.ACCIDENT.3': '浴室',
    'SAFETY.TYPE.PLACE.FALLING.ACCIDENT.4': '走廊',
    'SAFETY.TYPE.PLACE.FALLING.ACCIDENT.5': 'Test lab',
    'SAFETY.TYPE.PLACE.FALLING.ACCIDENT.0': '其他',

    'SAFETY.PATIENT.RISK.FACTORS.1': 'Unsteady Gait',
    'SAFETY.PATIENT.RISK.FACTORS.2': 'Lost Balance',
    'SAFETY.PATIENT.RISK.FACTORS.3': 'Visual Impairment',
    'SAFETY.PATIENT.RISK.FACTORS.4': 'Bowel&Bladder Need',
    'SAFETY.PATIENT.RISK.FACTORS.5': 'Lighting',
    'SAFETY.PATIENT.RISK.FACTORS.6': 'Floor',
    'SAFETY.PATIENT.RISK.FACTORS.7': 'Cluttered Area',
    'SAFETY.PATIENT.RISK.FACTORS.8': 'Need Item Out Of Reach',

    'SAFETY.PATIENT.RISK.INJURY.1': 'No Injury',
    'SAFETY.PATIENT.RISK.INJURY.2': 'Pain',
    'SAFETY.PATIENT.RISK.INJURY.3': 'Bruising',
    'SAFETY.PATIENT.RISK.INJURY.4': 'Hematoma',
    'SAFETY.PATIENT.RISK.INJURY.5': 'Abrasion',
    'SAFETY.PATIENT.RISK.INJURY.6': 'Laceration',
    'SAFETY.PATIENT.RISK.INJURY.7': 'Sprain/Strain',
    'SAFETY.PATIENT.RISK.INJURY.8': 'Dislocation',
    'SAFETY.PATIENT.RISK.INJURY.9': 'Fracture',
    'SAFETY.PATIENT.RISK.INJURY.0': '其他',

    'SAFETY.TYPE.FALL.TYPE.1': 'While using bed',
    'SAFETY.TYPE.FALL.TYPE.2': 'While using\nmedical equipment',
    'SAFETY.TYPE.FALL.TYPE.3': 'While walking',
    'SAFETY.TYPE.FALL.TYPE.4': 'While using chair',

    'SAFETY.TYPE.RISK.FACTOR.1': 'Broken bed wheels',
    'SAFETY.TYPE.RISK.FACTOR.2': 'Lower rail',
    'SAFETY.TYPE.RISK.FACTOR.3': 'Wet floors',
    'SAFETY.TYPE.RISK.FACTOR.4': 'Too big,\ntoo small shoes',
    'SAFETY.TYPE.RISK.FACTOR.5': 'Tripping on objects',
    'SAFETY.TYPE.RISK.FACTOR.0': '其他',

    'SAFETY.TYPE.PRESCRIPTION.1': '劑量',
    'SAFETY.TYPE.PRESCRIPTION.2': '患者',
    'SAFETY.TYPE.PRESCRIPTION.3': '途徑',
    'SAFETY.TYPE.PRESCRIPTION.4': '藥物',
    'SAFETY.TYPE.PRESCRIPTION.0': '其他',

    'SAFETY.TYPE.CONFIRM.1': '未確認',
    'SAFETY.TYPE.CONFIRM.2': '未核對患者信息後給藥',
    'SAFETY.TYPE.CONFIRM.3': '未核對藥物後給藥',
    'SAFETY.TYPE.CONFIRM.4': '未核對劑量後給藥',
    'SAFETY.TYPE.CONFIRM.5': '未核對途徑後給藥',
    'SAFETY.TYPE.CONFIRM.6': '未核對劑量卡後給藥',
    'SAFETY.TYPE.CONFIRM.7': '未核對有效日期',

    'SAFETY.TYPE.INTERPRETATION.1': '處方解釋錯誤',
    'SAFETY.TYPE.INTERPRETATION.2': '藥物卡誤解',

    'SAFETY.OTHER.TYPE.1': '不良反應',
    'SAFETY.OTHER.TYPE.2': '手術併發症',
    'SAFETY.OTHER.TYPE.3': '設備故障',
    'SAFETY.OTHER.TYPE.0': '其他',

    'SAFETY.ACCIDENT.RESULT.1': 'Treatment needed',
    'SAFETY.ACCIDENT.RESULT.2': 'Need in further observation',
    'SAFETY.ACCIDENT.RESULT.3': 'No need in treatment and observation',

    // KOOS2
    'KOOS.SYMPTOMS.1': '从不',
    'KOOS.SYMPTOMS.2': '很少',
    'KOOS.SYMPTOMS.3': '有时',
    'KOOS.SYMPTOMS.4': '经常',
    'KOOS.SYMPTOMS.5': '总是',

    'KOOS.STIFFNESS.1': '无',
    'KOOS.STIFFNESS.2': '轻微',
    'KOOS.STIFFNESS.3': '中等',
    'KOOS.STIFFNESS.4': '严重',
    'KOOS.STIFFNESS.5': '极度',

    'KOOS.PAIN.1': '从不',
    'KOOS.PAIN.2': '每月',
    'KOOS.PAIN.3': '每周',
    'KOOS.PAIN.4': '每天',
    'KOOS.PAIN.5': '总是',

    'KOOS.PAIN.TOW.1': '无',
    'KOOS.PAIN.TOW.2': '轻微',
    'KOOS.PAIN.TOW.3': '中等',
    'KOOS.PAIN.TOW.4': '严重',
    'KOOS.PAIN.TOW.5': '极度',

    'KOOS.DAILYFUNCTION.1': '无',
    'KOOS.DAILYFUNCTION.2': '轻微',
    'KOOS.DAILYFUNCTION.3': '中等',
    'KOOS.DAILYFUNCTION.4': '严重',
    'KOOS.DAILYFUNCTION.5': '极度',

    'KOOS.SPORTS.1': '无',
    'KOOS.SPORTS.2': '轻微',
    'KOOS.SPORTS.3': '中等',
    'KOOS.SPORTS.4': '严重',
    'KOOS.SPORTS.5': '极度',

    'KOOS.LIFEQUALITY.1': '从不',
    'KOOS.LIFEQUALITY.2': '每月',
    'KOOS.LIFEQUALITY.3': '每周',
    'KOOS.LIFEQUALITY.4': '每天',
    'KOOS.LIFEQUALITY.5': '总是',

    'KOOS.LIFEQUALITY.TWO.1': '无',
    'KOOS.LIFEQUALITY.TWO.2': '轻微',
    'KOOS.LIFEQUALITY.TWO.3': '适度',
    'KOOS.LIFEQUALITY.TWO.4': '严重',
    'KOOS.LIFEQUALITY.TWO.5': '极度',

    'KOOS.LIFEQUALITY.THREE.1': '无',
    'KOOS.LIFEQUALITY.THREE.2': '轻微',
    'KOOS.LIFEQUALITY.THREE.3': '中等',
    'KOOS.LIFEQUALITY.THREE.4': '严重',
    'KOOS.LIFEQUALITY.THREE.5': '极度',

    // STarTScreening
    'STARTSCREENING.SCORE.0': '否（0分）',
    'STARTSCREENING.SCORE.1': '是（1分）',

    'STARTSCREENING.SCORE.FIVE.0': '无 (0 point)',
    'STARTSCREENING.SCORE.FIVE.1': 'Slightly (0 point)',
    'STARTSCREENING.SCORE.FIVE.2': '适度 (0 point)',
    'STARTSCREENING.SCORE.FIVE.3': 'Very much (1 point)',
    'STARTSCREENING.SCORE.FIVE.4': '极度 (1 point)',

    // transfusion
    'BLOOD.RECORD.SIDE.EFFECT.1': 'Y',
    'BLOOD.RECORD.SIDE.EFFECT.2': 'N',

    // dialysis
    'DIALYSIS.DIALYSIS_INFO.ROUTE.0': '其他',
    'DIALYSIS.DIALYSIS_INFO.ROUTE.1': '門診',
    'DIALYSIS.DIALYSIS_INFO.ROUTE.2': '急診',
    'DIALYSIS.DIALYSIS_INFO.ROUTE.3': '住院',

    'DIALYSIS.DIALYSIS_INFO.BLOOD_VESSEL.0': '其他',
    'DIALYSIS.DIALYSIS_INFO.BLOOD_VESSEL.1': '動靜脈瘻管\n(AVF)',
    'DIALYSIS.DIALYSIS_INFO.BLOOD_VESSEL.2': '人工血管瘻管\n(AVG)',
    'DIALYSIS.DIALYSIS_INFO.BLOOD_VESSEL.3': '長期導管\n(Perm c)',
    'DIALYSIS.DIALYSIS_INFO.BLOOD_VESSEL.4': '頸靜脈導管\n(JVC)',
    'DIALYSIS.DIALYSIS_INFO.BLOOD_VESSEL.5': '上腔靜脈導管\n(SVC)',
    'DIALYSIS.DIALYSIS_INFO.BLOOD_VESSEL.6': '股靜脈導管\n(FVC)',

    // emergency
    'EMERGENCY.ACCIDENT_TYPE.1': 'urgent',
    'EMERGENCY.ACCIDENT_TYPE.2': 'emergency',
    'EMERGENCY.ACCIDENT_TYPE.3': 'non-emergency',

    'EMERGENCY.DIVISION.1': 'Accident',
    'EMERGENCY.DIVISION.2': 'Disaster',
    'EMERGENCY.DIVISION.3': 'acute disease',
    'EMERGENCY.DIVISION.4': 'the rapid deterioration of chronic diseases',
    'EMERGENCY.DIVISION.0': '其他.',

    // childbirth
    'CHILDBIRTH.BABY_STATUS.GENDER.1': '男孩',
    'CHILDBIRTH.BABY_STATUS.GENDER.2': '女孩',

    'CHILDBIRTH.YES_OR_NO.1': '否',
    'CHILDBIRTH.YES_OR_NO.2': '是',

    'CHILDBIRTH.PLACENTA_REMOVAL.METHOD.1': '自然分离',
    'CHILDBIRTH.PLACENTA_REMOVAL.METHOD.2': '水分离',

    'EMERGENGY.RESULT.0': '入院',
    'EMERGENGY.RESULT.1': '转院',
    'EMERGENGY.RESULT.2': '回家',
    'EMERGENGY.RESULT.3': '死亡',
    'EMERGENGY.RESULT.4': '其他',

    // home_care
    'HOME_CARE.INSURANCE_TYPE.1': '保险',
    'HOME_CARE.INSURANCE_TYPE.2': '福利',
    'HOME_CARE.INSURANCE_TYPE.3': '退伍军人',

    'HOME_CARE.RESIDENCE.1': '公寓',
    'HOME_CARE.RESIDENCE.2': '集体',
    'HOME_CARE.RESIDENCE.3': '单独',

    'HOME_CARE.SANITARY.1': '良好',
    'HOME_CARE.SANITARY.2': '有缺陷',

    'HOME_CARE.SAFETY.1': '良好',
    'HOME_CARE.SAFETY.2': '有缺陷',

    // diet_nutrition
    'DIET_NUTRITION.CLASSIFICATION.1': '환자',
    'DIET_NUTRITION.CLASSIFICATION.2': '보호자',
  },
};

export default locale;
